import React from "react";
import { Offcanvas } from "bootstrap";

const CyberIntelIcon = () => {
  const openCyberIntel = () => {
    const el = document.getElementById("staticBackdropCyberIntel");
    if (!el) return;

    const instance =
      Offcanvas.getInstance(el) || new Offcanvas(el);
    instance.show();
  };

  return (
    <button
      onClick={openCyberIntel}
      className="d-flex justify-content-center align-items-center rounded-circle border-0 shadow-sm"
      style={{
        width: 50,
        height: 50,
        background: "#344266",
        cursor: "pointer",
        // zIndex: 1055
      }}
      aria-label="Open Chat"
    >
      <i className="bi bi-exclamation-circle-fill fs-3 text-white z-2"></i>
      <div className="pulsatingDotBig position-absolute z-1"></div>
    </button>
  );
};

export default CyberIntelIcon;
